import RecommendedProducts from "./RecommendedProducts";

export default RecommendedProducts;
